module.exports = __webpack_public_path__ + "img/11_66.ce0712c7.png";